import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ViewList from '@mui/icons-material/ViewList';
import { isValid } from '@totalsoft/pure-validations-react';
import ChecklistGeneralDataComponent from './ChecklistGeneralDataComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';

export const ChecklistGeneralDataCard = ({
  checklist,
  targetAreas,
  requiredDocTypes,
  onSave,
  onPropertyChanged,
  saving,
  validation,
  genericEntityFlows,
  genericEntityBusinessStates,
  id
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('Checklist.GeneralData')}
      actions={
        <IconButton
          color='transparent'
          type='save'
          fontSize='medium'
          title={t('Tooltips.Checklist.SaveChanges')}
          onClick={onSave}
          disabled={!checklist?.changed || !(validation |> isValid) || saving}
        />
      }
    >
      <>
        <Prompt when={id !== undefined && checklist?.changed} message={t('Checklist.LeavingWithoutSavingChecklist')} />
        <ChecklistGeneralDataComponent
          checklist={checklist}
          onPropertyChanged={onPropertyChanged}
          targetAreas={targetAreas}
          requiredDocTypes={requiredDocTypes}
          validation={validation}
          genericEntityFlows={genericEntityFlows}
          genericEntityBusinessStates={genericEntityBusinessStates}
        />
      </>
    </Card>
  );
};

ChecklistGeneralDataCard.propTypes = {
  checklist: PropTypes.object,
  targetAreas: PropTypes.array.isRequired,
  requiredDocTypes: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  genericEntityFlows: PropTypes.array.isRequired,
  genericEntityBusinessStates: PropTypes.array.isRequired,
  id: PropTypes.number
};

export default ChecklistGeneralDataCard;
